// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "stock_order".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { stockOrderStatusValues } from '@borradh-workspace/labels';
/** Response atom for the "stock_order" table (1:1 with a DB row, on the wire). */
export const stockOrderAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    supplierId: z.string().nullable(),
    locationId: z.string().nullable(),
    status: z.enum(stockOrderStatusValues),
    expectedByDate: z.string().datetime().nullable(),
    notes: z.string().nullable(),
    createdById: z.string(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=stockOrder.js.map